import { queryKey } from 'Shared/const/queryKey';
import type { GetBannersOkDto } from 'viewup-api';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import type { BannerQueryKey } from './queries';

export const useGetBanners = (
  params?: QueryParam<
    GetBannersOkDto,
    unknown,
    GetBannersOkDto,
    BannerQueryKey['list']['queryKey']
  >,
) => {
  return useSDQuery<GetBannersOkDto, unknown, GetBannersOkDto, BannerQueryKey['list']['queryKey']>({
    ...params?.options,
    ...queryKey.banners.list,
  });
};
